import React from "react";
import { IScoreboard } from "../../../../services/api/Scoreboard";
import Formatter from "../../../../services/utils/Formatter";
import OdometerCounter from "react-odometerjs";
import "./assets/css/odometer.css";

interface OdometerProps {
    score: IScoreboard;
    scoreYtd: IScoreboard;
    forecast: string;
    cre: string;
    date: Date;
    useHeader?: Boolean;
    isCountry?: Boolean;
    onUpdate?:Function;
}

const Odometer: React.FC<OdometerProps> = ({ score, scoreYtd, forecast, cre, date, useHeader = true, isCountry, onUpdate}) => {
    const value = 
        forecast === "FW4" ? score.tradeSalesForecastWeek4 :
        forecast === "FW3" ? score.tradeSalesForecastWeek3 :
        forecast === "FW2" ? score.tradeSalesForecastWeek2 :
        forecast === "FW1" ? score.tradeSalesForecastWeek1 :
        forecast === "MTDW4" ? score.tradeSalesMonthTodayWeek4 :
        forecast === "MTDW3" ? score.tradeSalesMonthTodayWeek3 :
        forecast === "MTDW2" ? score.tradeSalesMonthTodayWeek2 :
        forecast === "MTDW1" ? score.tradeSalesMonthTodayWeek1 :
        score.tradeSalesActual;
    const valueCRE = Math.max(1, 
        cre === "BP" ? score.tradeSalesBusinessPlan :
        cre === "SRE" ? score.tradeSalesSRE :
                cre === "LE" ? score.tradeSalesLE :
                    cre === "OP" ? score.tradeSalesOP :
        score.tradeSalesFRE);

    const ytdValue = 
        forecast === "FW4" ? scoreYtd.tradeSalesForecastWeek4 :
        forecast === "FW3" ? scoreYtd.tradeSalesForecastWeek3 :
        forecast === "FW2" ? scoreYtd.tradeSalesForecastWeek2 :
        forecast === "FW1" ? scoreYtd.tradeSalesForecastWeek1 :
        forecast === "MTDW4" ? scoreYtd.tradeSalesMonthTodayWeek4 :
        forecast === "MTDW3" ? scoreYtd.tradeSalesMonthTodayWeek3 :
        forecast === "MTDW2" ? scoreYtd.tradeSalesMonthTodayWeek2 :
        forecast === "MTDW1" ? scoreYtd.tradeSalesMonthTodayWeek1 :
        scoreYtd.tradeSalesActual;
    const ytdValueCRE = Math.max(1, 
        cre === "BP" ? scoreYtd.tradeSalesBusinessPlan :
        cre === "SRE" ? scoreYtd.tradeSalesSRE :
                cre === "LE" ? scoreYtd.tradeSalesLE :
                    cre === "OP" ? scoreYtd.tradeSalesOP :
        scoreYtd.tradeSalesFRE);

    const odometerValue = normalizeNumber(Math.round(value));
    const Percent = value / valueCRE * 100;
    const YTDPercent = ytdValue / ytdValueCRE * 100;

    onUpdate && onUpdate(value, (value / valueCRE * 100));

    function FormatValues(value: Number) {
        let s: string = value.toString();
        while (s.length < 9) s = "0" + s;
        return s.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    function GetProgressBar(value: number) {
        return (
            <span
                className={
                    "bar " + (value <= 50 ? "red" : value >= 100 ? "green" : "yellow")
                }
                style={{ width: value + "%" }}
            ></span>
        );
    }
    function normalizeNumber(value: number) {
        let s: string = value.toString();
        while (s.length < 9) s = "0" + s;
        return parseInt("1" + s);
    }

    function getDuration(time: number) {
        return (
            "#od" +
            score.code +
            " .odometer.odometer-auto-theme.odometer-animating-up .odometer-ribbon-inner, " +
            "#od" +
            score.code +
            " .odometer.odometer-theme-minimal.odometer-animating-up .odometer-ribbon-inner," +
            "#od" +
            score.code +
            " .odometer.odometer-auto-theme.odometer-animating-down.odometer-animating .odometer-ribbon-inner, .odometer.odometer-theme-minimal.odometer-animating-down.odometer-animating .odometer-ribbon-inner {" +
            "-webkit-transition-duration: " +
            time +
            "s !important;" +
            "-moz-transition-duration: " +
            time +
            "s !important;" +
            "-ms-transition-duration: " +
            time +
            "s !important;" +
            "-o-transition-duration: " +
            time +
            "s !important;" +
            "transition-duration: " +
            time +
            "s !important" +
            "}"
        );
    }

    return (
        <div
            className={isCountry ? "country" : "totalCount"}
            id={"od" + score.code}
        >
            <style>{getDuration(1.25)}</style>
            {useHeader ? (
                <div className="header">
                    <h2>{score.name}</h2>
                    <OdometerCounter
                        value={odometerValue}
                        minIntegerLen={9}
                        //duration={Step * 5}
                        //animation="count"
                        format="(.ddd)"
                    />
                </div>
            ) : (
                    <OdometerCounter
                        value={odometerValue}
                        minIntegerLen={9}
                        //duration={Step * 5}
                        format="(.ddd)"
                    />
                )}

            <div className="grid grid-2">
                <div className="box">
                    <h2>FORECAST</h2>
                    <div className="barContainer">
                        {" "}
                        {GetProgressBar(Percent)}{" "}
                    </div>
                    <div className="numbers">
                        <span className="count">{FormatValues(valueCRE)}</span>
                        <span className="percent">
                            {Formatter.DisplayPercent(Percent)}<br /> <span>vs {cre}</span>
                        </span>
                    </div>
                </div>
                <div className="box">
                    <h2>FORECAST YTD</h2>
                    <div className="barContainer"> {GetProgressBar(YTDPercent)} </div>
                    <div className="numbers">
                        <span className="count">{FormatValues(ytdValueCRE)}</span>
                        <span className="percent">
                            {Formatter.DisplayPercent(YTDPercent)}<br /> <span>vs {cre}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Odometer;
